import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconSteeringWheelBlack({
	size = "100",
	...props
}: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<g fill="none" fillRule="evenodd">
				<g fill="#000" fillRule="nonzero">
					<path d="M11.686 6.501a5.47 5.47 0 1 0 0 10.94 5.47 5.47 0 0 0 0-10.94m0 .718a4.751 4.751 0 1 1 0 9.503 4.751 4.751 0 0 1 0-9.503" />
					<path d="M11.686 3.512a8.459 8.459 0 1 0 0 16.917 8.459 8.459 0 0 0 0-16.917m0 .718a7.74 7.74 0 1 1 0 15.48 7.74 7.74 0 0 1 0-15.48" />
				</g>
				<path
					fill="#000"
					fillRule="nonzero"
					d="M11.827 6.59c.263 0 .479.147.498.333l.002.027v3.896c0 .199-.224.36-.5.36-.264 0-.48-.147-.5-.333V6.95c0-.199.223-.36.5-.36M11.827 2.019c.263 0 .479.146.498.332l.002.027v1.493c0 .198-.224.36-.5.36-.264 0-.48-.147-.5-.333v-1.52c0-.198.223-.36.5-.36M6.965 9.205a.36.36 0 0 1 .465-.142l.026.014 3.441 2.016a.36.36 0 0 1-.337.633l-.026-.014-3.44-2.015a.36.36 0 0 1-.129-.492M3.067 6.995a.36.36 0 0 1 .465-.145l.026.013 1.293.747a.36.36 0 0 1-.333.635l-.027-.013L3.2 7.485a.36.36 0 0 1-.132-.49M10.534 12.229a.36.36 0 0 1 .388.604l-.025.016-3.44 2.014a.36.36 0 0 1-.388-.604l.024-.016zM4.491 15.71a.36.36 0 0 1 .384.606l-.024.015-1.293.747a.36.36 0 0 1-.384-.606l.025-.016zM11.827 12.736c.263 0 .479.147.498.333l.002.026v3.897c0 .198-.224.359-.5.359-.264 0-.48-.147-.5-.332v-3.924c0-.198.223-.359.5-.359M11.826 19.711c.264 0 .48.147.499.332l.001.027v1.493c0 .199-.224.36-.5.36-.263 0-.48-.147-.498-.333l-.002-.027V20.07c0-.198.224-.359.5-.359M12.348 12.354a.36.36 0 0 1 .465-.146l.026.014 3.374 1.948a.36.36 0 0 1-.333.636l-.026-.014-3.374-1.948a.36.36 0 0 1-.132-.49M18.389 15.841a.36.36 0 0 1 .464-.145l.026.014 1.293.746a.36.36 0 0 1-.333.636l-.026-.014-1.293-.746a.36.36 0 0 1-.131-.49M15.854 9.15a.36.36 0 0 1 .384.606l-.025.015-3.374 1.948a.36.36 0 0 1-.384-.606l.025-.015zM19.813 6.863a.36.36 0 0 1 .384.607l-.024.015-1.293.747a.36.36 0 0 1-.384-.606l.025-.016z"
				/>
				<path
					fill="#E42822"
					d="M5.786 14.428a.328.328 0 1 1-.606.25.328.328 0 0 1 .606-.25M14.604 18.154a.328.328 0 1 1-.606.251.328.328 0 0 1 .606-.251M9.483 5.49a.328.328 0 1 1-.605.252.328.328 0 0 1 .605-.251M18.259 9.261a.328.328 0 1 1-.606.251.328.328 0 0 1 .606-.25M9.277 17.903a.327.327 0 1 1-.25.605.327.327 0 0 1 .25-.605M18.148 14.302a.328.328 0 1 1-.25.606.328.328 0 0 1 .25-.606M5.572 8.97a.328.328 0 1 1-.251.605.328.328 0 0 1 .251-.606M14.443 5.43a.328.328 0 1 1-.25.607.328.328 0 0 1 .25-.607"
				/>
				<path
					fill="#E42822"
					fillRule="nonzero"
					d="M11.686 10.53a1.437 1.437 0 1 0 0 2.874 1.437 1.437 0 0 0 0-2.875m0 .717a.719.719 0 1 1 0 1.438.719.719 0 0 1 0-1.438"
				/>
			</g>
		</svg>
	);
}
